import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingHomepageComponent } from './landing-homepage.component';

const landingRoutes: Routes = [
    { path: 'landing', component: LandingHomepageComponent }
];
@NgModule({
    imports: [RouterModule.forChild(landingRoutes)],
    exports: [RouterModule],
    providers: []
})
export class LandingRoutingModule { }